/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorHeading from 'sites/allas/components/labrador/Heading';

export const DynamicLabradorHeading: typeof LabradorHeading = (props) => {
    return <ErrorBoundary><LabradorHeading {...props} /></ErrorBoundary>;
}
export type DynamicLabradorHeadingProps = PropsFromComponent<typeof LabradorHeading>;
